import React, { useState, useRef, useEffect } from 'react';
import './EmailVerification.css';
import popupImage from '../images/popup.png';

const EmailVerification = ({ email, onClose, onVerify, errorMessage }) => {
    const [codes, setCodes] = useState(['', '', '', '']);
    const inputRefs = useRef([]);

    const handleCodeChange = (index, event) => {
        let value = event.target.value.slice(0, 1); 
        if (!/^\d*$/.test(value)) {
            value = ''; 
        }
        const newCodes = [...codes];
        newCodes[index] = value;
        setCodes(newCodes);

        if (value && index < inputRefs.current.length - 1) {
            inputRefs.current[index + 1].focus();
        }
    };

    const handleKeyDown = (index, event) => {
        if (event.key === 'Backspace' && !codes[index] && index > 0) {
            inputRefs.current[index - 1].focus();
        }
    };

    const handleVerifyClick = () => {
        const verificationCode = codes.join('');
        onVerify(verificationCode);
    };

    const isVerifyEnabled = codes.every(code => code !== '');

    useEffect(() => {
        if (inputRefs.current[0]) {
            inputRefs.current[0].focus();
        }
    }, []);

    return (
        <div className="code-verification-overlay">
            <div className="code-verification-box">
                <button type="button" className="exit-button" onClick={onClose}>
                    ×
                </button>
            <img src={popupImage} alt="User" className="popup-image" />
                <h4>Verify Email</h4>
                <p>We've sent a code to your email <strong>{email}</strong></p>
                <div className="code-input-container">
                    {codes.map((code, index) => (
                        <input
                            key={index}
                            type="text"
                            value={code}
                            onChange={(event) => handleCodeChange(index, event)}
                            onKeyDown={(event) => handleKeyDown(index, event)}
                            maxLength="1"
                            className="code-input"
                            ref={(el) => inputRefs.current[index] = el}
                        />
                    ))}
                </div>
                {errorMessage && <p className="error-message">{errorMessage}</p>}
                <div className="button-group">
                    <button
                        onClick={handleVerifyClick}
                        className={`verify-button ${isVerifyEnabled ? 'enabled' : ''}`}
                        disabled={!isVerifyEnabled}
                    >
                        Verify
                    </button>
                </div>
                <small className="note"><span className="note-highlight">Note:</span> If you didn't get a code, please make sure you've entered the correct email address above</small>
            </div>
        </div>
    );
};

export default EmailVerification;
